import { Suspense } from "react";
import { styled, Typography } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { useUuidLayoutContext } from "hooks/routerHooks";

import { MeasuresPageDrawerContent } from "components/drawerContent/MeasuresPageDrawerContent";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { MeasuresPageSkeleton } from "components/skeletons/MeasuresPageSkeleton";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";

export function MeasuresPage() {
  const { t } = useTranslation();
  const { mapRef, uuid, footerRef, mapOverlayContainer } =
    useUuidLayoutContext();

  return (
    <StyledPaddedPaper data-tour="step-3">
      <Typography variant="h2" component="h1">
        {t("label.measuresInMyProjectArea")}
      </Typography>
      <ErrorBoundary
        FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
      >
        <Suspense
          fallback={
            <MeasuresPageSkeleton
              footerRef={footerRef}
              mapOverlayContainer={mapOverlayContainer}
            />
          }
        >
          <MeasuresPageDrawerContent
            mapRef={mapRef}
            uuid={uuid}
            footerRef={footerRef}
          />
        </Suspense>
      </ErrorBoundary>
    </StyledPaddedPaper>
  );
}
const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  height: 100%;
`;
